var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _rect2, _rect3, _rect4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect5, _rect6, _rect7, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserInterface(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 536.69,
    height: 597.08,
    viewBox: "0 0 536.69 597.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -58.3,
    y1: -230.8,
    x2: 370.35,
    y2: 361.96,
    gradientTransform: "matrix(1, 0, 0, -1, -0.02, 428)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 253.4,
    y1: 212.3,
    x2: 252.84,
    y2: 233.89,
    gradientTransform: "translate(0 -168)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 310.07,
    y1: 390.38,
    x2: 309.23,
    y2: 571.99,
    gradientTransform: "translate(0 -168)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 576.62,
    y1: 30.69,
    x2: 653.8,
    y2: 148.98,
    gradientTransform: "matrix(1, 0, 0, -1, -148.76, 428)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 440.65,
    y1: 411.01,
    x2: 445.72,
    y2: 434.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 436.82,
    y1: 131.71,
    x2: 462.01,
    y2: 132.17,
    gradientTransform: "matrix(1, 0, 0, -1, -0.05, 428.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 587.02,
    y1: 135.78,
    x2: 581.83,
    y2: 133.03,
    gradientTransform: "matrix(1, 0, 0, -1, -148.76, 428)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 490.36,
    y1: 95.38,
    x2: 518.5,
    y2: 95.38,
    gradientTransform: "matrix(1, 0, 0, -1, -148.76, 428)",
    xlinkHref: "#linear-gradient-6"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "23. Arranging FIles") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M523.2,569.6c-17.3,2-34.6,3.7-51.9,5.2a7.46,7.46,0,0,0,.7,1.2c1.8,2.7,5.5,3.2,8.6,4.5s5.9,5,3.9,7.6c-1,1.3-2.8,1.7-4.4,1.9l-17.9,3c-21.8,3.6-44.8,7.2-65.4-.7-8.5-3.3-9.1-8.2-6.2-12.3-110.7,4.8-221.9,1.1-332.8-2.5-9,0-19.1-2.4-21.5-11.5,57.1-25.7,112.5-25.8,174.4-27.5l217.5-5.8c3.7-.1,7.7-.1,10.9,1.8s5,5.7,7.7,8.5c8,8.3,21.4,6.6,32.9,5.7a126.35,126.35,0,0,1,49.6,6.3c2.2.7,4.6,1.7,5.7,3.7C538,564.3,529.5,568.9,523.2,569.6Z",
    transform: "translate(-0.03 0.05)",
    fill: "#1d2741",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.4,2c-29.2,6.1-54.9,23.5-77.1,43.4s-42,42.5-64.7,61.9c-35.1,30.1-80.1,57.1-89,102.5-7.1,36.4,12.1,72.8,13,109.9C15.1,347.8,5.2,375,3.1,403,1,430.6,7.3,459.8,25.4,480.7c25.8,29.8,70,36.8,109.1,31.2s75.9-21.6,114.4-30.1c46.4-10.2,94.7-9.4,142-4.3,28.9,3.1,59.2,7.6,86.4-2.8,24.2-9.2,43.3-29.8,52.5-54s8.9-51.5,1-76.1c-10.9-34.1-35-62.3-50.4-94.6-13.1-27.5-19.6-57.5-26.8-87.1-4.8-19.6-10.2-39.9-23.5-55.1-15.1-17.5-38-25.6-58.3-36.7C322.7,44.3,296.5-11.4,232.4,2Z",
    transform: "translate(-0.03 0.05)",
    fill: "#e5c15c",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.7,36.5H293.1V571.3H119.7a31.6,31.6,0,0,1-31.6-31.6h0V68.1a31.6,31.6,0,0,1,31.6-31.6Z",
    transform: "translate(-0.03 0.05)",
    fill: "#e5c15c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.7,36.5H293.1V571.3H119.7a31.6,31.6,0,0,1-31.6-31.6h0V68.1a31.6,31.6,0,0,1,31.6-31.6Z",
    transform: "translate(-0.03 0.05)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.9,36.5H367.4a37.3,37.3,0,0,1,37.3,37.3V534a37.3,37.3,0,0,1-37.3,37.3H138.9A37.3,37.3,0,0,1,101.6,534V73.8A37.3,37.3,0,0,1,138.9,36.5Z",
    transform: "translate(-0.03 0.05)",
    fill: "#e5c15c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M391.4,68.6V513.4a19,19,0,0,1-18.9,18.9H133.8A18.86,18.86,0,0,1,115,513.4h0V68.6a18.86,18.86,0,0,1,18.8-18.9H181v5.9a19,19,0,0,0,19,19H305.9a19,19,0,0,0,19-19V49.7h47.6a18.88,18.88,0,0,1,18.9,18.9Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.8,51.3h54.7a2.48,2.48,0,0,1,2.5,2.5v.5a2.48,2.48,0,0,1-2.5,2.5H225.8a2.48,2.48,0,0,1-2.5-2.5v-.5A2.54,2.54,0,0,1,225.8,51.3Z",
    transform: "translate(-0.03 0.05)",
    fill: "url(#linear-gradient-2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M370.7,49.7V451.8a34.14,34.14,0,0,1-34.1,34.1H115V68.6a18.86,18.86,0,0,1,18.8-18.9H181v5.9a19,19,0,0,0,19,19H305.9a19,19,0,0,0,19-19V49.7Z",
    transform: "translate(-0.03 0.05)",
    fill: "#ebebf0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5,227H450.1a18.31,18.31,0,0,1,18.3,18.3v69.1a18.31,18.31,0,0,1-18.3,18.3H169.5a18.31,18.31,0,0,1-18.3-18.3V245.3A18.31,18.31,0,0,1,169.5,227Z",
    transform: "translate(-0.03 0.05)",
    fill: "#e5c15c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5,227H450.1a18.31,18.31,0,0,1,18.3,18.3v69.1a18.31,18.31,0,0,1-18.3,18.3H169.5a18.31,18.31,0,0,1-18.3-18.3V245.3A18.31,18.31,0,0,1,169.5,227Z",
    transform: "translate(-0.03 0.05)",
    fill: "url(#linear-gradient-3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175,220.4H455.6a18.31,18.31,0,0,1,18.3,18.3v69.1a18.31,18.31,0,0,1-18.3,18.3H175a18.31,18.31,0,0,1-18.3-18.3V238.7A18.31,18.31,0,0,1,175,220.4Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 143.17,
    y: 102.85,
    width: 47.4,
    height: 47.4,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.4,239.8h48a9.5,9.5,0,0,1,9.5,9.5v48a9.5,9.5,0,0,1-9.5,9.5h-48a9.5,9.5,0,0,1-9.5-9.5v-48A9.43,9.43,0,0,1,185.4,239.8Z",
    transform: "translate(-0.03 0.05)",
    fill: "#ebebf0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 143.17,
    y: 161.65,
    width: 47.4,
    height: 47.4,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 143.17,
    y: 348.65,
    width: 47.4,
    height: 47.4,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 143.17,
    y: 407.45,
    width: 47.4,
    height: 47.4,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.8,288.4v8.9a9.5,9.5,0,0,1-9.5,9.5h-48a9.5,9.5,0,0,1-9.5-9.5v-8.9a66.72,66.72,0,0,1,26.5-10.3,14.2,14.2,0,1,1,13.7.1C230.2,280.5,242.8,288.4,242.8,288.4Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff",
    opacity: 0.38,
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M450.2,251.5h-181a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3h181a3,3,0,0,1,3,3h0A3,3,0,0,1,450.2,251.5Z",
    transform: "translate(-0.03 0.05)",
    fill: "#ebebf0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M208.3,115.2H377.9a2.8,2.8,0,0,1,2.8,2.8h0a2.8,2.8,0,0,1-2.8,2.8H208.3a2.8,2.8,0,0,1-2.8-2.8h0A2.8,2.8,0,0,1,208.3,115.2Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M377.9,139.8H208.3a2.8,2.8,0,0,1-2.8-2.8h0a2.8,2.8,0,0,1,2.8-2.8H377.9a2.8,2.8,0,0,1,2.8,2.8h0A2.86,2.86,0,0,1,377.9,139.8Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M377.9,178H208.3a2.8,2.8,0,0,1-2.8-2.8h0a2.8,2.8,0,0,1,2.8-2.8H377.9a2.8,2.8,0,0,1,2.8,2.8h0A2.86,2.86,0,0,1,377.9,178Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M377.9,194.1H208.3a2.8,2.8,0,0,1-2.8-2.8h0a2.8,2.8,0,0,1,2.8-2.8H377.9a2.8,2.8,0,0,1,2.8,2.8h0A2.86,2.86,0,0,1,377.9,194.1Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M377.9,367.1H208.3a2.8,2.8,0,0,1-2.8-2.8h0a2.8,2.8,0,0,1,2.8-2.8H377.9a2.8,2.8,0,0,1,2.8,2.8h0A2.86,2.86,0,0,1,377.9,367.1Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M377.9,383.2H208.3a2.8,2.8,0,0,1-2.8-2.8h0a2.8,2.8,0,0,1,2.8-2.8H377.9a2.8,2.8,0,0,1,2.8,2.8h0A2.86,2.86,0,0,1,377.9,383.2Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M377.9,425.9H208.3a2.8,2.8,0,0,1-2.8-2.8h0a2.8,2.8,0,0,1,2.8-2.8H377.9a2.8,2.8,0,0,1,2.8,2.8h0A2.86,2.86,0,0,1,377.9,425.9Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M377.9,442H208.3a2.8,2.8,0,0,1-2.8-2.8h0a2.8,2.8,0,0,1,2.8-2.8H377.9a2.8,2.8,0,0,1,2.8,2.8h0A2.86,2.86,0,0,1,377.9,442Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M450.2,270.8h-181a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3h181a3,3,0,0,1,3,3h0A3,3,0,0,1,450.2,270.8Z",
    transform: "translate(-0.03 0.05)",
    fill: "#ebebf0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M450.2,290.1h-181a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3h181a3,3,0,0,1,3,3h0A3,3,0,0,1,450.2,290.1Z",
    transform: "translate(-0.03 0.05)",
    fill: "#ebebf0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M415.8,420.9l-11.4,83a21.75,21.75,0,0,0,1.1,10.4l20.4,60,11.9-3.7-9-59.7a9.26,9.26,0,0,1,.2-3.7l15.5-53.4,6.7,120.4h11l9.5-118.9c3.2-19.8-2.7-34.5-2.7-34.5Z",
    transform: "translate(-0.03 0.05)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M474.2,347.7v57c0,7-1.1,12.6-8.1,12.6H417.3c-7,0-7.2-5.6-7.3-12.6l-.4-38.8s-10.5,18.8-18.9,17-33.3-36.2-33.3-36.2l12.4-10.4,20.9,21s3.4-7.6,8.2-24.7,20.8-17.2,20.8-17.2h42.4C477.4,315.4,474.2,347.7,474.2,347.7Z",
    transform: "translate(-0.03 0.05)",
    fill: "#e5c15c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M473.9,290.1s15.5,31.8,16.3,42.7-15.8,25.6-15.8,25.6l-12.4-43h11.8V290.1Z",
    transform: "translate(-0.03 0.05)",
    fill: "#e5c15c"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M473.9,290.1s15.5,31.8,16.3,42.7-15.8,25.6-15.8,25.6l-12.4-43h11.8V290.1Z",
    transform: "translate(-0.03 0.05)",
    fill: "url(#linear-gradient-4)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M474.5,358.4s10.1-27.8,9-34.1-9.6-26.5-9.6-26.5v17.7l-14.9.3Z",
    transform: "translate(-0.03 0.05)",
    fill: "#e5c15c"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 415.77,
    y: 417.05,
    width: 53.2,
    height: 3.9,
    fill: "#e5c15c"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 415.77,
    y: 417.05,
    width: 53.2,
    height: 3.9,
    fill: "url(#linear-gradient-5)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 433.87,
    y: 276.75,
    width: 15.3,
    height: 39,
    fill: "url(#linear-gradient-6)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M449.2,272.4v43.3h-8.1v-2.6a5.8,5.8,0,0,0-5.8-5.8h-.5a14.53,14.53,0,0,1-14.6-14.5h0V272.5h29Z",
    transform: "translate(-0.03 0.05)",
    fill: "url(#linear-gradient-7)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M424.1,259.2c3.2-1.8,7.1-2,10.9-2.1l7.9-.2a31.33,31.33,0,0,1,5.3.2,13,13,0,0,1,10.7,15h0a13.82,13.82,0,0,1-.8,2.7,6.64,6.64,0,0,0-.6,2,8.86,8.86,0,0,0,1.1,3.1c1.1,3-.7,6.2-2.7,8.6s-4.4,4.9-4.7,8.1c-.1,1,0,2.2-.7,3a2.56,2.56,0,0,1-3.2.2,7.84,7.84,0,0,1-2.2-2.6c.1,1.5-2,2.3-3.3,1.6a5.17,5.17,0,0,1-2.2-3.7,12.1,12.1,0,0,0-1.3-4.2c-.7-1-1.8-1.7-2.1-2.9-.6-2,1.4-4.2.6-6.2-.6-1.6-2.9-2.1-4.5-1.4a9.83,9.83,0,0,0-3.7,3.6c1.5-2,.3-5.4-1.3-7-2.5-2.7-6.2-.4-8.3-2.3C415.1,270.9,420.6,261.2,424.1,259.2Z",
    transform: "translate(-0.03 0.05)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M445.8,315.6s-6,7.8-14.2,7.8-32.3,23.6-33.9,30.7-7,3.2-7,3.2,3.4-7.6,8.2-24.7,20.8-17.2,20.8-17.2h21.6Z",
    transform: "translate(-0.03 0.05)",
    fill: "#fff",
    opacity: 0.25
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M437.7,569.6l4.2,10.3-16.9,8L409.3,589s-2.7-10.3,4.6-11.2a24.82,24.82,0,0,0,11.8-4.6Z",
    transform: "translate(-0.03 0.05)",
    fill: "#222a72"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M451.1,574.2h0a12.83,12.83,0,0,0-7.8,10.5l-.4,4.3h19.2V574.2Z",
    transform: "translate(-0.03 0.05)",
    fill: "#222a72"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M369.7,336.4l-8.1-10s-2.8-10.7-4.3-4.1c-.9,3.7-3.3,10.4-3.3,10.4H341.6s8.7,9.2,12.4,10.9a20,20,0,0,0,5.3,1.5Z",
    transform: "translate(-0.03 0.05)",
    fill: "url(#linear-gradient-8)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInterface);
export default __webpack_public_path__ + "static/media/user_interface.bf73d87b35eb1091ba5cc05e2061bb82.svg";
export { ForwardRef as ReactComponent };